import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

export const GetWalletList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Wallet/GetWalletList`,
    params
  );
  return res;
};

export const AddUpdateWallet = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Wallet/AddUpdateWallet`,
    params
  );
  return res;
};

export const GetWalletModel = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Wallet/GetWalletModel?WalletKeyID=${KeyID}`
  );
  return res;
};

export const ChangeWalletStatus = async (KeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Wallet/ChangeWalletStatus?WalletKeyID=${KeyID}`
  );
  return res;
};

export const CategoryLookupListAPI = async (id) => {
  const url = id
    ? `${Base_Url}/ExpenseCategory/GetExpenseCategoryLookupList?ExpenseTypeID=${id}`
    : `${Base_Url}/ExpenseCategory/GetExpenseCategoryLookupList`;

  const res = await getApiWithAuthorization(`${url}`);
  return res;
};

export const ProjectLookupListAPI = async (keyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Project/GetProjectLookupList?userKeyID=${keyID}`
  );
  return res;
};

export const VendorLookupListAPI = async () => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Parties/GetClientLookupList?Type=Vendor`
  );
  return res;
};

export const GetExpenseModelAPI = async (ExpenseKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Expense/GetExpenseModel?ExpenseKeyID=${ExpenseKeyID}`
  );
  return res;
};

export const AddUpdateExpenseAPI = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Expense/AddUpdateExpense`,
    params
  );
  return res;
};

export const GetExpenseList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Base_Url}/Expense/GetExpenseList`,
    params
  );
  return res;
};

export const GetWalletDetails = async (walletKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Wallet/GetWalletDetails?WalletKeyID=${walletKeyID}`
  );
  return res;
};

export const GetExpenseDetails = async (expenseKeyID) => {
  const res = await getApiWithAuthorization(
    `${Base_Url}/Expense/GetExpenseDetails?ExpenseKeyID=${expenseKeyID}`
  );
  return res;
};
